import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';

(function (Drupal, once) {

  Drupal.behaviors.bendrejatMasonry = {

    attach(context) {

      once(
        'bendrejat-masonry',
        '.views-masonry .view-content',
        context
      ).forEach((container) => {

        imagesLoaded(container, () => {

          let masonry;

          const initMasonry = () => {

            if (masonry) {
              masonry.destroy();
            }

            masonry = new Masonry(container, {
              itemSelector: '.views-row',
              columnWidth: '.views-row',
              percentPosition: true,
              horizontalOrder: true,
              transitionDuration: '0.4s'
            });

          };

          initMasonry();

          container.querySelectorAll('img').forEach((img) => {
            img.addEventListener('load', () => {
              if (masonry) {
                masonry.layout();
              }
            });
          });

        });

      });

    }

  };

})(Drupal, once);